(function(){
  if(typeof gsap === 'undefined') return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var art = document.getElementById('craftArt');
  var visual = document.querySelector('.craft-visual');
  if(!art || !visual) return;

  ScrollTrigger.getAll().forEach(function(st){
    if(st.trigger && st.trigger.id === 'craft') st.kill();
  });
  gsap.killTweensOf(['.craft-photo-card','.callout','.swatches i','.craft-headline .row span','#craftP','#craftCta','#craftArt']);

  gsap.set(art,{opacity:0,scale:.62,y:80,rotateX:34,transformPerspective:1100,transformOrigin:'50% 75%'});
  gsap.set('.craft-banner h2',{opacity:0,y:16});
  gsap.set('.craft-sub',{opacity:0,y:14});

  if(reduce){
    gsap.set([art,'.craft-banner h2','.craft-sub'],{opacity:1,scale:1,y:0,rotateX:0});
    gsap.set(['#craftP','#craftCta'],{opacity:1,y:0});
    gsap.set('.craft-headline .row span',{y:'0%'});
    return;
  }

  gsap.to('.craft-banner h2',{opacity:1,y:0,duration:.7,ease:'power3.out',
    scrollTrigger:{trigger:'.craft-banner',start:'top 88%'}});
  gsap.to('.craft-sub',{opacity:1,y:0,duration:.7,ease:'power3.out',delay:.12,
    scrollTrigger:{trigger:'.craft-sub',start:'top 88%'}});

  var tl = gsap.timeline({scrollTrigger:{trigger:'#craft',start:'top 66%'}});

  tl.to(art,{opacity:1,scale:1,y:0,rotateX:0,duration:1.2,ease:'back.out(1.6)'})
    .to(art,{scale:1.035,duration:.2,ease:'power2.out'},'-=.2')
    .to(art,{scale:1,duration:.55,ease:'elastic.out(1,.5)'})
    .to('.craft-headline .row span',{y:'0%',duration:.9,stagger:.13,ease:'power3.out'},'-=1.3')
    .to('#craftP',{opacity:.95,y:0,duration:.7,ease:'power2.out'},'-=.65')
    .to('#craftCta',{opacity:1,y:0,duration:.6,ease:'back.out(2.2)'},'-=.45');

  gsap.to(art,{y:'+=13',duration:4.2,repeat:-1,yoyo:true,ease:'sine.inOut',delay:2.2});

  if(window.matchMedia('(min-width:901px)').matches){
    visual.addEventListener('mousemove',function(e){
      var r = visual.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5;
      var y = (e.clientY - r.top) / r.height - .5;
      gsap.to(art,{rotateY:x*15,rotateX:-y*12,duration:.7,ease:'power2.out',overwrite:'auto'});
    });
    visual.addEventListener('mouseleave',function(){
      gsap.to(art,{rotateY:0,rotateX:0,duration:1,ease:'elastic.out(1,.55)',overwrite:'auto'});
    });
  }
})();
